import React from "react";

const NailArtNearMeBook = () => {
  return (
    <div className="hairSalonNearMeHead">
      <h3>How to Book Your Appointment for Nail Art Near Me</h3>
      <p>
        Booking your nail art near me appointment at SCENT is simple and
        convenient. You can easily reach out to us through our website or give
        us a call to reserve your spot. Whether you prefer to schedule a
        last-minute appointment or plan ahead for a special event, our team will
        ensure that your visit is seamless and stress-free.
      </p>
    </div>
  );
};

export default NailArtNearMeBook;
